import { inputRMOValidation } from "./rmo-input-validations";

export const copyFromMo = (copyCheckboxEl) => {
    const repeaterMo = copyCheckboxEl.closest('.repeater-mo-individual')
    const firstRepeater = document.querySelector(".repeater-mo-individual");
    copyCheckboxEl.addEventListener('change', (e) => {
        let firstLocationName = firstRepeater.querySelector("[id^=wu-input-location-name]")?.value
        let firstCityName = firstRepeater.querySelector("[id^=wu-input-city]")?.value
        const firstStateCountryValuesEls = firstRepeater.querySelectorAll('.wuds-dropdown span.wu-input_input')
        const purchaseLocationEl = repeaterMo.querySelector('[id^="purchase_location"]')
        const locationNameEl = purchaseLocationEl.querySelector("[id^=wu-input-location-name]")
        const CityNameEL = purchaseLocationEl.querySelector("[id^=wu-input-city]")
        let stateCountryValuesEls = purchaseLocationEl.querySelectorAll('.wuds-dropdown')
        if(!e.target.checked) {
            firstLocationName = ''
            firstCityName = ''
            locationNameEl.removeAttribute("disabled");
            locationNameEl.classList.remove("bk-grey-01");
            CityNameEL.removeAttribute("disabled");
            CityNameEL.classList.remove("bk-grey-01");
        } else {
          locationNameEl.setAttribute("disabled", true);
          locationNameEl.classList.add("bk-grey-01");
          CityNameEL.setAttribute("disabled", true);
          CityNameEL.classList.add("bk-grey-01");
        }

        locationNameEl.value = firstLocationName
        locationNameEl.setAttribute("value", firstLocationName)
        CityNameEL.value = firstCityName;
        CityNameEL.setAttribute("value", firstCityName)
        inputRMOValidation(CityNameEL);
        inputRMOValidation(locationNameEl);
        stateCountryValuesEls = Array.from(stateCountryValuesEls).filter((el) => el.querySelector("span.wu-input_input"))
        Array.from(stateCountryValuesEls).forEach((el, indexMain, the_array) => {
          const index = the_array.length-1-indexMain
          const spanEl = stateCountryValuesEls[index].querySelector('span.wu-input_input')
          if(spanEl) {
            if( e.target.checked ) {
              const lis =  stateCountryValuesEls[index].querySelectorAll('ul li')
              Array.from(lis).forEach((li) => {
                if(li.innerText === firstStateCountryValuesEls[index+1]?.innerText) {
                  li.click()
                }
              })
              stateCountryValuesEls[index].setAttribute('style','pointer-events: none;')
              spanEl.classList.add("bk-grey-01")
            } else {
              stateCountryValuesEls[index].removeAttribute('style')
              spanEl.classList.remove("bk-grey-01")
            }
          }
        })
    })
}